// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    quickOrderSearchStyles,
    QuickOrderSearchStyles,
} from "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch";
import { ProductSelectorStyles } from "@pacific/Overrides/Components/ProductSelector";
import { xScreen } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

export interface XngQuickOrderSearchStyles extends QuickOrderSearchStyles {
    productSelector?: ProductSelectorStyles;
}

(quickOrderSearchStyles as XngQuickOrderSearchStyles).productSelector = {
    container: { gap: 30 },
    searchGridItem: {
        width: [12, 12, 4, 5, 6],
        css: css`
            min-width: 343px;
        `,
    },
    qtyGridItem: {
        width: [4, 3, 2, 2, 2],
        css: css`
            &&& {
                max-width: fit-content;
                margin-bottom: 4px;
                padding-inline: 0;
                ${xScreen("lt", "md")} {
                    padding: 0 0 0 15px;
                    height: fit-content;
                }
            }
        `,
    },
    unitOfMeasureGridItem: {
        css: css`
            &:empty {
                display: none;
            }
            &&&& {
                max-width: fit-content;
                padding-left: 0;
                ${xScreen("lt", "md")} {
                    padding: 0 0 0 15px;
                    height: fit-content;
                }
            }
        `,
    },
    productQuantityOrderedStyles: {
        actionsStyles: {
            wrapper: {
                css: css`
                    height: 38px;
                    width: 100px;
                `,
            },
            actionClickable: {
                css: css`
                    height: 36px;
                `,
            },
            quantityOrderedTextField: {
                cssOverrides: {
                    inputSelect: css`
                        height: 36px;
                    `,
                },
            },
        },
    },
    buttonGridItem: {
        css: css`
            &&&& {
                max-width: fit-content;
                margin-bottom: 4px;
                ${xScreen("lt", "md")} {
                    padding-top: 0;
                }
            }
        `,
    },
    selectButton: {
        sizeVariant: "medium",
        css: css`
            margin-top: 0;
        `,
    },
    clearIcon: {
        size: 14,
        css: css`
            position: absolute;
            right: 42px;
            top: 26px;
            cursor: pointer;
            ${xScreen("lt", "md")} {
                top: 26px;
            }
        `,
    },
};
